<button type="button" class="sg-tile cursor" [ngClass]="class" [class.sg-tile--active]="active">
    <mlp-ng-icon class="sg-tile__icon-action" [ngClass]="{'-active': active}" [name]="faIcon" size="small"></mlp-ng-icon>
    <span class="sg-tile__text"><ng-content></ng-content></span>
</button>